import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change as changeFieldValue, Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import {
    renderFieldSelect
} from '../../util/inputs';
import MapaVeiculoCategoriaPoltrona from './MapaVeiculoCategoriaPoltrona';
import { listaTipoPrecos as listaAcoes, mapaTiposAssentosCategorias } from '../../util/constantsUtil';

class ModalConfiguracaoCategoriaPoltrona extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tipoPrecoPrimeiroAndarPadrao: this.carregarTipoPrecoAndar(1),
            tipoPrecoSegundoAndarPadrao: this.carregarTipoPrecoAndar(2),
            listaAssentosPrimeiroAndar: this.carregarListaAssento(),
            listaAssentosSegundoAndar: [],
            tipoAcaoSelecionada: {},
            tipoAcaoSelecionadaSegundoAndar: {},

            fileiraSelecionada: null,
            assentoSelecionado: null,
            listaCategoriasPoltronas: this.carregarListaCategoriaPoltronas()
        }
    }

    componentDidUpdate(prevProps) {
        const veiculoSelcionado = prevProps.veiculoItinerarioSelecionado;

        if (!this.idItinerario && veiculoSelcionado.value.descricao != this.props.veiculoItinerarioSelecionado.value.descricao) {
            this.props.verificarAndarSelecionado(1);
            this.limparConfiguracaoMapaVeiculo();
            this.props.preencherListaCategoriasPoltronas([]);

        }
    }

    componentWillUnmount() {
        this.limparConfiguracaoMapaVeiculo();
    }

    carregarTipoPrecoAndar(andar) {
        let tipoPrecoPadrao = null;
        if (this.props.idItinerario && this.props.itinerarioSelecionado.andar) {
            tipoPrecoPadrao = this.props.itinerarioSelecionado.valorTipoPrecoPadrao && this.props.itinerarioSelecionado.valorTipoPrecoPadrao;
        }

        if ((andar === 1 && !this.props.idItinerario)
            || (this.props.idItinerario)) {
            this.props.preencherTipoPrechoPrimeiroAndarPadrao(tipoPrecoPadrao);
        } else {
            this.props.preencherTipoPrechoSegundoAndarPadrao(tipoPrecoPadrao);
        }

        return tipoPrecoPadrao;
    }

    carregarListaAssento() {
        const lista = [];

        if (this.props.idItinerario) {
            const andar = this.props.itinerarioSelecionado.andar;
            const valorTipoPrecoPadrao = this.props.itinerarioSelecionado.valorTipoPrecoPadrao;
            const poltronas = this.props.itinerarioSelecionado.poltronas;
            const mapaVeiculo = this.props.itinerarioSelecionado.veiculoDto.mapaVeiculoDto

            if (mapaVeiculo) {
                const fileiras = andar === 1 ? mapaVeiculo.fileirasPrimeiroAndar : mapaVeiculo.fileirasSegundoAndar;
                fileiras.forEach(fileira => {
                    const assentos = fileira.assentos;
                    assentos.forEach(assento => {
                        if (assento.tipoAssento === 'NORMAL') {
                            let poltrona = poltronas.find(p => p.numero == assento.numero && p.tipoPreco !== valorTipoPrecoPadrao);
                            if (poltrona) {
                                let item = listaAcoes.find(it => it.id == poltrona.tipoPreco);
                                lista.push({ id: item.id, descricao: item.descricao, tratarMarcacao: item.tratarMarcacao });

                            }
                        }
                    })
                });
            }
        }

        return this.removerDadosDuplicados(lista);

    }

    removerDadosDuplicados(original) {
        const reduced = [];

        original.forEach((item) => {
            var duplicated = reduced.findIndex(redItem => {
                return item.id == redItem.id;
            }) > -1;

            if (!duplicated) {
                reduced.push(item);
            }
        });

        return reduced;
    }

    carregarListaCategoriaPoltronas() {
        const lista = [];

        if (this.props.idItinerario) {
            const andar = this.props.itinerarioSelecionado.andar;
            const valorTipoPrecoPadrao = this.props.itinerarioSelecionado.valorTipoPrecoPadrao;
            const poltronas = this.props.itinerarioSelecionado.poltronas;
            const mapaVeiculo = this.props.itinerarioSelecionado.veiculoDto.mapaVeiculoDto

            if (mapaVeiculo) {
                const fileiras = this.props.itinerarioSelecionado.andar === 1 ? mapaVeiculo.fileirasPrimeiroAndar : mapaVeiculo.fileirasSegundoAndar;
                fileiras.forEach(fileira => {
                    let assentos = fileira.assentos;
                    assentos.forEach(assento => {
                        if (assento.tipoAssento === 'NORMAL') {
                            let poltrona = poltronas.find(p => p.numero == assento.numero && p.tipoPreco != valorTipoPrecoPadrao);
                            if (poltrona) {
                                lista.push({
                                    fileira,
                                    assento,
                                    andar,
                                    tipoPreco: poltrona.tipoPreco
                                })
                            }
                        }
                    })
                });
            }
        }

        this.props.preencherListaCategoriasPoltronas(lista);

        return lista;
    }

    limparConfiguracaoMapaVeiculo() {
        this.setState({
            listaCategoriasPoltronas: [],
            listaAssentosPrimeiroAndar: [],
            listaAssentosSegundoAndar: [],
            tipoPrecoPrimeiroAndarPadrao: null,
            tipoPrecoSegundoAndarPadrao: null,
            tipoAcaoSelecionada: {},
            tipoAcaoSelecionadaSegundoAndar: {}
        });
    }


    exibirComboTipoPreco(name, label, callback) {
        return <div className="col-12 col-sm-4 col-md-4">
            <Field name={name}
                options={this.props.tiposPreco.map(elemento => ({
                    descricao: elemento.descricaoTipoPreco,
                    nome: elemento.tipoPreco
                }))}
                component={renderFieldSelect}
                label={label}
                placeholder='Selecione a categoria'
                onChange={(e) => callback(e)} />
        </div>
    }

    marcarPoltrona(fileira, assento) {
        if (this.state.tipoAcaoSelecionada.id && this.props.andarSelecionado == 1) {
            const tipoPreco = this.state.tipoAcaoSelecionada.id
            let listaCategoriasPoltronas = this.state.listaCategoriasPoltronas;

            if (this.state.listaCategoriasPoltronas.length <= 0 || this.state.listaCategoriasPoltronas.filter(it => it.fileira.id == fileira.id && it.assento.id == assento.id).length <= 0) {

                const andar = this.props.idItinerario ? this.props.itinerarioSelecionado.andar : 1;

                listaCategoriasPoltronas.push({
                    fileira,
                    assento,
                    andar: andar,
                    tipoPreco
                })
            } else {
                const index = listaCategoriasPoltronas.findIndex((elemento) => {
                    if (elemento.fileira.id === fileira.id && elemento.assento.id == assento.id && elemento.andar == this.props.andarSelecionado) {
                        return true;
                    }

                    return false;
                })

                listaCategoriasPoltronas.splice(index, 1);

            }

            this.props.preencherListaCategoriasPoltronas(listaCategoriasPoltronas);

            this.setState({ listaCategoriasPoltronas: listaCategoriasPoltronas, fileiraSelecionada: fileira, assentoSelecionado: assento });
        }

        if (this.state.tipoAcaoSelecionadaSegundoAndar.id && this.props.andarSelecionado == 2) {
            const tipoPreco = this.state.tipoAcaoSelecionadaSegundoAndar.id
            let listaCategoriasPoltronas = this.state.listaCategoriasPoltronas;

            if (this.state.listaCategoriasPoltronas.length <= 0 || this.state.listaCategoriasPoltronas.filter(it => it.fileira.id == fileira.id && it.assento.id == assento.id).length <= 0) {
                listaCategoriasPoltronas.push({
                    fileira,
                    assento,
                    andar: 2,
                    tipoPreco
                })
            } else {
                const index = listaCategoriasPoltronas.findIndex((elemento) => {
                    if (elemento.fileira.id === fileira.id && elemento.assento.id == assento.id && elemento.andar == this.props.andarSelecionado) {
                        return true;
                    }

                    return false;
                })

                listaCategoriasPoltronas.splice(index, 1);

            }

            this.props.preencherListaCategoriasPoltronas(listaCategoriasPoltronas);

            this.setState({ listaCategoriasPoltronas: listaCategoriasPoltronas, fileiraSelecionada: fileira, assentoSelecionado: assento });
        }
    }

    renderAcao(acao, indice) {
        return <tr key={`acao${indice}`} className={`acao${indice}`}><td style={{
            cursor: 'pointer',
            backgroundColor: this.state.tipoAcaoSelecionada.id === acao.id ? mapaTiposAssentosCategorias.get(acao.id).cor : ''
        }}
            onClick={() => this.setState({ tipoAcaoSelecionada: acao })}>
            <i className="material-icons nav-icon" style={{
                position: 'absolute',
                marginLeft: '-20px',
                color: mapaTiposAssentosCategorias.get(acao.id).cor
            }}>&#xe866;</i><span className='ml-2'>{acao.descricao}</span></td><td><span style={{ cursor: 'pointer' }} onClick={() => {
                const lista = this.state.listaAssentosPrimeiroAndar.filter(it => it.id != acao.id);
                let acaoQualquer = this.state.tipoAcaoSelecionada;

                if (lista.length > 0 && this.state.tipoAcaoSelecionada.id === acao.id) {
                    acaoQualquer = lista[0];
                } else if (lista.length <= 0) {
                    acaoQualquer = {}
                }

                let listaCategoriasPoltronas = []
                if (this.props.idItinerario) {
                    listaCategoriasPoltronas = [...this.state.listaCategoriasPoltronas.filter(it => it.tipoPreco != acao.id)];
                } else {
                    listaCategoriasPoltronas = [...this.state.listaCategoriasPoltronas.filter(it => it.andar == 2), ...this.state.listaCategoriasPoltronas.filter(it => it.tipoPreco != acao.id && it.andar == 1)];
                }

                this.setState({
                    listaAssentosPrimeiroAndar: lista,
                    listaCategoriasPoltronas: listaCategoriasPoltronas,
                    tipoAcaoSelecionada: acaoQualquer
                })

                this.props.preencherListaCategoriasPoltronas(listaCategoriasPoltronas);
            }
            }><i className="material-icons nav-icon">&#xe872;</i></span></td></tr>
    }

    exibirAcoes() {
        return <tabela className="table table-sm">
            <tr>
                <th>Categoria</th>
                <th>Remover</th>
            </tr>
            <tbody>
                {this.state.listaAssentosPrimeiroAndar.map((acao, index) => this.renderAcao(acao, index))}
                {this.state.listaAssentosPrimeiroAndar.length <= 0 && <tr>
                    <td colSpan='2'>Selecione as categorias acima para marcar as poltronas</td>
                </tr>}
            </tbody>
        </tabela>
    }

    renderAcaoSegundoAndar(acao, indice) {
        return <tr key={`acao${indice}`} className={`acao${indice}`}><td style={{
            cursor: 'pointer',
            backgroundColor: this.state.tipoAcaoSelecionadaSegundoAndar.id === acao.id ? mapaTiposAssentosCategorias.get(acao.id).cor : ''
        }}
            onClick={() => this.setState({ tipoAcaoSelecionadaSegundoAndar: acao })}>
            <i className="material-icons nav-icon" style={{
                position: 'absolute',
                marginLeft: '-20px',
                color: mapaTiposAssentosCategorias.get(acao.id).cor
            }}>&#xe866;</i><span className='ml-2'>{acao.descricao}</span></td><td><span style={{ cursor: 'pointer' }} onClick={() => {
                const lista = this.state.listaAssentosSegundoAndar.filter(it => it.id != acao.id);
                let acaoQualquer = this.state.tipoAcaoSelecionadaSegundoAndar;

                if (lista.length > 0 && this.state.tipoAcaoSelecionadaSegundoAndar.id === acao.id) {
                    acaoQualquer = lista[0];
                } else if (lista.length <= 0) {
                    acaoQualquer = {}
                }

                const listaCategoriasPoltronas = [...this.state.listaCategoriasPoltronas.filter(it => it.andar == 1), ...this.state.listaCategoriasPoltronas.filter(it => it.tipoPreco != acao.id && it.andar == 2)];
                this.setState({
                    listaAssentosSegundoAndar: lista,
                    listaCategoriasPoltronas: listaCategoriasPoltronas,
                    tipoAcaoSelecionadaSegundoAndar: acaoQualquer
                })

                this.props.preencherListaCategoriasPoltronas(listaCategoriasPoltronas);
            }
            }><i className="material-icons nav-icon">&#xe872;</i></span></td></tr>
    }

    exibirAcoesSegundoAndar() {
        return <tabela className="table table-sm">
            <tr>
                <th>Categoria</th>
                <th>Remover</th>
            </tr>
            <tbody>
                {this.state.listaAssentosSegundoAndar.map((acao, index) => this.renderAcaoSegundoAndar(acao, index))}
                {this.state.listaAssentosSegundoAndar.length <= 0 && <tr>
                    <td colSpan='2'>Selecione as categorias acima para marcar as poltronas</td>
                </tr>}
            </tbody>
        </tabela>
    }

    ehTabelaTipoPrecosPrimeriroAndar() {        
        return  this.props.andarSelecionado == 1;
    }

    exibeTabelaTipoPrecosPrimeriroAndar() {
        return this.exibirAcoes();
    }

    exibeTabelaTipoPrecosSegundoAndar() {
        if (!this.props.idItinerario) {
            if ((this.seVeiculoPossuiDoisAndares() && this.props.andarSelecionado == 2)
                || (this.seVeiculoPossuiDoisAndares() && this.props.itinerarioSelecionado.andar == 2)) {
                return this.exibirAcoesSegundoAndar();
            }
        }
    }

    handleSelecionaCategoriaPoltronaPrimeiroAndar(e) {
        if (!this.seVeiculoPossuiDoisAndares()
            || (this.seVeiculoPossuiDoisAndares() && this.props.andarSelecionado == 1)
            || (this.seVeiculoPossuiDoisAndares() && this.props.itinerarioSelecionado.andar == 1)) {
            if (this.state.tipoPrecoPrimeiroAndarPadrao == null) {
                this.setState({ tipoPrecoPrimeiroAndarPadrao: e.value });
                this.setState({ listaAssentosPrimeiroAndar: this.state.listaAssentosPrimeiroAndar.filter(it => it.id != e.value) });

                this.props.preencherTipoPrechoPrimeiroAndarPadrao(e.value);
            }

            if (!this.state.listaAssentosPrimeiroAndar.map(it => it.id).includes(e.value) && this.state.tipoPrecoPrimeiroAndarPadrao != null && this.state.tipoPrecoPrimeiroAndarPadrao != e.value) {
                let listaAssentosPrimeiroAndar = this.state.listaAssentosPrimeiroAndar;
                listaAssentosPrimeiroAndar = [...listaAssentosPrimeiroAndar, ...listaAcoes.filter(it => it.id == e.value)]

                this.setState({ listaAssentosPrimeiroAndar });
            }

        }
    }

    handleSelecionaCategoriaPoltronaSegundoAndar(e) {
        if (!this.props.idItinerario) {
            if ((this.seVeiculoPossuiDoisAndares() && this.props.andarSelecionado == 2)
                || (this.seVeiculoPossuiDoisAndares() && this.props.itinerarioSelecionado.andar == 2)) {
                if (this.state.tipoPrecoSegundoAndarPadrao == null) {
                    this.setState({ tipoPrecoSegundoAndarPadrao: e.value });
                    this.setState({ listaAssentosSegundoAndar: this.state.listaAssentosSegundoAndar.filter(it => it.id != e.value) });

                    this.props.preencherTipoPrechoSegundoAndarPadrao(e.value);
                }

                if (!this.state.listaAssentosSegundoAndar.map(it => it.id).includes(e.value) && this.state.tipoPrecoSegundoAndarPadrao != null && this.state.tipoPrecoSegundoAndarPadrao != e.value) {
                    let listaAssentosSegundoAndar = this.state.listaAssentosSegundoAndar;
                    listaAssentosSegundoAndar = [...listaAssentosSegundoAndar, ...listaAcoes.filter(it => it.id == e.value)]

                    this.setState({ listaAssentosSegundoAndar });
                }

            }
        }        
    }

    seVeiculoPossuiDoisAndares() {
        return (this.props.veiculoItinerarioSelecionado && this.props.veiculoItinerarioSelecionado.value.seDoisAndares)
            || (this.props.itinerarioSelecionado.veiculoDto && this.props.itinerarioSelecionado.veiculoDto.seDoisAndares);
    }

    render() {
        return (
            <div>
                {this.props.andarSelecionado == 1 && this.exibirComboTipoPreco('modalConfiuracaoTipoPrecoPrimeiroAndar', this.seVeiculoPossuiDoisAndares() && !this.props.idItinerario ? 'Categoria 1° andar' : 'Categoria', this.handleSelecionaCategoriaPoltronaPrimeiroAndar.bind(this))}
                {this.props.andarSelecionado == 2 && this.seVeiculoPossuiDoisAndares() ? this.exibirComboTipoPreco('modalConfiuracaoTipoPrecoSegundoAndar', 'Categoria 2° andar', this.handleSelecionaCategoriaPoltronaSegundoAndar.bind(this)) : ''}

                {this.props.andarSelecionado == 1 && this.state.tipoPrecoPrimeiroAndarPadrao == null && this.seVeiculoPossuiDoisAndares() && <p className='ml-3'>Informe a opção padrão para a Categoria das Poltronas - 1° andar!</p>} {this.state.tipoPrecoPrimeiroAndarPadrao == null && !this.seVeiculoPossuiDoisAndares() && <p className='ml-3'>Informe a opção padrão para a Categoria das Poltronas!</p>}
                {this.props.andarSelecionado == 2 && this.state.tipoPrecoSegundoAndarPadrao == null && this.seVeiculoPossuiDoisAndares() && <p className='ml-3'>Informe a opção padrão para a Categoria das Poltronas - 2° andar!</p>}

                {this.props.andarSelecionado == 1 && this.state.tipoPrecoPrimeiroAndarPadrao != null && <p className='ml-3'>Categoria Padrão - {this.state.tipoPrecoPrimeiroAndarPadrao} <span style={{ position: 'relative', top: '6px', color: 'red', cursor: 'pointer' }} onClick={() => { this.setState({ tipoPrecoPrimeiroAndarPadrao: null }); this.props.preencherTipoPrechoPrimeiroAndarPadrao(null); }}><i className="material-icons nav-icon">&#xe872;</i></span></p>}
                {this.props.andarSelecionado == 2 && this.state.tipoPrecoSegundoAndarPadrao != null && <p className='ml-3'>Categoria Padrão - {this.state.tipoPrecoSegundoAndarPadrao} <span style={{ position: 'relative', top: '6px', color: 'red', cursor: 'pointer' }} onClick={() => { this.setState({ tipoPrecoSegundoAndarPadrao: null }); this.props.preencherTipoPrechoSegundoAndarPadrao(null); }}><i className="material-icons nav-icon">&#xe872;</i></span></p>}

                <div>
                    {this.ehTabelaTipoPrecosPrimeriroAndar() ? this.exibeTabelaTipoPrecosPrimeriroAndar() : this.exibeTabelaTipoPrecosSegundoAndar()}
                </div>

                <MapaVeiculoCategoriaPoltrona
                    idItinerario={this.props.idItinerario}
                    exibeTipoCategoriaUnica={this.props.exibeTipoCategoriaUnica}
                    fileiraSelecionada={this.state.fileiraSelecionada}
                    assentoSelecionado={this.state.assentoSelecionado}
                    tipoAcaoSelecionada={this.state.tipoAcaoSelecionada}
                    tipoAcaoSelecionadaSegundoAndar={this.state.tipoAcaoSelecionadaSegundoAndar}
                    listaCategoriasPoltronas={this.state.listaCategoriasPoltronas}
                    andarSelecionado={this.props.andarSelecionado}
                    verificarAndarSelecionado={this.props.verificarAndarSelecionado}
                    marcarPoltrona={this.marcarPoltrona.bind(this)} />
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        veiculoItinerarioSelecionado: state.veiculoItinerarioSelecionado,
        itinerarioSelecionado: state.itinerarioSelecionado,
        tiposPreco: state.tiposPreco,
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroItinerario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalConfiguracaoCategoriaPoltrona));